import { Box, Chip, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  ownsAssetsMarker: {
    width: 10,
    height: 10,
    borderRadius: 2,
    backgroundColor: theme.palette.warning.main,
    display: 'inline-block',
  },
}));

const LEVEL_LABELS: Record<string, string> = {
  company: 'Company',
  function: 'Function',
  'sub-function': 'Sub-Function',
  xp: 'XP',
};

/**
 * Surfaces the Team Data Model v2 classification (PAT-676) on the Group
 * entity overview page — team/level/ownsAssets are only annotations today,
 * with no other place on the entity page they'd show up without opening
 * the edit form. No badge is shown for level=team — that's the default,
 * not a classification worth calling out.
 */
export function EntityTeamFlagsCard() {
  const classes = useStyles();
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};

  const level = annotations['team/level'];
  const levelLabel = level ? LEVEL_LABELS[level] : undefined;
  const ownsAssets = annotations['team/owns-assets'] === 'true';
  const hasAnyFlag = Boolean(levelLabel) || ownsAssets;

  if (!hasAnyFlag) {
    return null;
  }

  return (
    <Grid item xs={12} md={6}>
      <InfoCard title="Classification" variant="gridItem">
        <Box className={classes.row}>
          {levelLabel && <Chip label={levelLabel} size="small" />}
          {ownsAssets && (
            <Chip
              icon={<span className={classes.ownsAssetsMarker} />}
              label="Owns Assets"
              size="small"
              variant="outlined"
            />
          )}
        </Box>
      </InfoCard>
    </Grid>
  );
}
